import {blue, green, red} from '@mui/material/colors';

const tenantIdList = [
  {id: '3fa85f64-5717-4562-b3fc-2c963f66afa1', name: '3fa85f64-5717-4562-b3fc-2c963f66afa1', type: 1, color: red[500]},
  {id: '3fa85f64-5717-4562-b3fc-2c963f66afa2', name: '3fa85f64-5717-4562-b3fc-2c963f66afa2', type: 2, color: blue[500]},
  {id: '3fa85f64-5717-4562-b3fc-2c963f66afa3', name: '3fa85f64-5717-4562-b3fc-2c963f66afa3', type: 3, color: green[500]},
];
export default tenantIdList;
